import React, { Component } from 'react';
import { Row, Col, Button } from 'reactstrap';

import Link from 'react-router-dom/NavLink'
import PhonePreview from '../../../shared/components/PhonePreview';
import iconEngageChoose from '../../../shared/assets/engagement-choose.svg';
import iconEngageThisThat from '../../../shared/assets/engagement-this-that.svg';
import iconEngageVideo from '../../../shared/assets/engagement-video.svg';
import iconEngageQA from '../../../shared/assets/engagement-qa.svg';
import iconEngagePuzzle from '../../../shared/assets/engagement-puzzle.svg';

import DEMO_DATA from '../assets/data.js';
import Pills from "../../../shared/components/Pills";

const COVER_SECTION = '__COVER_SECTION__',
  CHOOSE_SECTION = '__CHOOSE_SECTION__',
  THIS_OR_THAT_SECTION = '__THIS_OR_THAT_SECTION__',
  RATABLE_SECTION = '__RATABLE_SECTION__',
  QA_SECTION = '__QA_SECTION__',
  PUZZLE_SECTION = '__PUZZLE_SECTION__',
  CONCLUSION_SECTION = '__CONCLUSION_SECTION__';

const SECTIONS_IN_ORDER = [
  COVER_SECTION,
  CHOOSE_SECTION,
  QA_SECTION,
  THIS_OR_THAT_SECTION,
  RATABLE_SECTION,
  PUZZLE_SECTION,
  CONCLUSION_SECTION
];

const COVER_PREVIEW_ID = '__FEED__',
  CHOOSE_PREVIEW_ID = '__CHOOSE__',
  THIS_OR_THAT_PREVIEW_ID = '__THIS_OR_THAT__',
  RATABLE_PREVIEW_ID = '__RATABLE__',
  QA_PREVIEW_ID='__QA__',
  PUZZLE_PREVIEW_ID='__PUZZLE__',
  CONCLUSION_PREVIEW_ID = '__CONCLUSION__';

const PREVIEW_IDS_IN_ORDER = [
  COVER_PREVIEW_ID,
  CHOOSE_PREVIEW_ID,
  QA_PREVIEW_ID,
  THIS_OR_THAT_PREVIEW_ID,
  RATABLE_PREVIEW_ID,
  PUZZLE_PREVIEW_ID,
  CONCLUSION_PREVIEW_ID
];


class OnboardingDemo extends Component {
  constructor(){
    super();

    this.state = {
      activeSection:COVER_SECTION,
      activePreviewEngagementId:COVER_PREVIEW_ID,
      showQAAnswer:false
    }
  }

  getNextButtonText(){
    const activeSection = this.state.activeSection;

    if(activeSection === COVER_SECTION) return 'Next: Multiple choice';
    if(activeSection === CHOOSE_SECTION) return 'Next: Trivia';
    if(activeSection === QA_SECTION) return 'Next: This or that';
    if(activeSection === THIS_OR_THAT_SECTION) return 'Next: Video';
    if(activeSection === RATABLE_SECTION) return 'Next: Puzzle';
    if(activeSection === PUZZLE_SECTION) return 'Next: Conclusion';

    return 'Next';
  }

  render(){
    const { activeSection, activePreviewEngagementId, showQAAnswer } = this.state;

    const isInvite = this.props.isInvite;

    const {campaign,brand,engagements} = DEMO_DATA;

    const nextIndex = SECTIONS_IN_ORDER.indexOf(activeSection) + 1,
      NEXT_SECTION = SECTIONS_IN_ORDER[nextIndex],
      NEXT_PREVIEW_ID = PREVIEW_IDS_IN_ORDER[nextIndex];
    const phonePreviewHeight = 420;

    return (
      <div className='OnboardingDemo'>
        <Row>
          <Col md={{ size: 4, offset: 2 }} xs='6'>
            <h1>Meet the Dabbl Experience</h1>
            <ul className='engagement-list'>
              <li
                className={activeSection === COVER_SECTION ? 'active' :''}
                onClick={() => this.setState({
                  activeSection:COVER_SECTION,
                  activePreviewEngagementId:COVER_PREVIEW_ID
                })}
              >
                <span className='icon'></span>
                Cover tile
              </li>
              <li
                className={activeSection === CHOOSE_SECTION ? 'active' :''}
                onClick={() => this.setState({
                  activeSection:CHOOSE_SECTION,
                  activePreviewEngagementId:CHOOSE_PREVIEW_ID
                })}
              >
                <img src={iconEngageChoose} alt='Choose' className='icon' />
                Multiple choice
              </li>
              <li
                className={activeSection === QA_SECTION ? 'active' :''}
                onClick={() => this.setState({
                  activeSection:QA_SECTION,
                  activePreviewEngagementId:QA_PREVIEW_ID,
                  showQAAnswer: false
                })}
              >
                <img src={iconEngageQA} alt='Video' className='icon' />
                Trivia
              </li>
              <li
                className={activeSection === THIS_OR_THAT_SECTION ? 'active' :''}
                onClick={() => this.setState({
                  activeSection:THIS_OR_THAT_SECTION,
                  activePreviewEngagementId:THIS_OR_THAT_PREVIEW_ID
                })}
              >
                <img src={iconEngageThisThat} alt='This or that' className='icon' />
                This or that
              </li>
              <li
                className={activeSection === RATABLE_SECTION ? 'active' :''}
                onClick={() => this.setState({
                  activeSection:RATABLE_SECTION,
                  activePreviewEngagementId:RATABLE_PREVIEW_ID
                })}
              >
                <img src={iconEngageVideo} alt='Video' className='icon' />
                Video
              </li>
              <li
                className={activeSection === PUZZLE_SECTION ? 'active' :''}
                onClick={() => this.setState({
                  activeSection:PUZZLE_SECTION,
                  activePreviewEngagementId:PUZZLE_PREVIEW_ID
                })}
              >
                <img src={iconEngagePuzzle} alt='Video' className='icon' />
                Puzzle
              </li>
              <li
                className={activeSection === CONCLUSION_SECTION ? 'active' :''}
                onClick={() => this.setState({
                  activeSection:CONCLUSION_SECTION,
                  activePreviewEngagementId:CONCLUSION_PREVIEW_ID
                })}
              >
                <span className='icon'></span>
                Conclusion
              </li>
            </ul>
          </Col>
          <Col md={{ size: 5 }} xs='6'>
            <br />
            <br />
            <br />
            <PhonePreview
              hideTotalValue
              phonePlatform='generic'
              align='left'
              activeEngagementId={activePreviewEngagementId}
              engagements={engagements}
              feedText={campaign.feedText}
              feedImageURL={campaign.feedImageURL}
              height={phonePreviewHeight}
              brandName={brand.name}
              logoURL={brand.logoURL}
              conclusionText={campaign.completionText}
              conclusionBackgroundColor={brand.primaryColor}
              completionImageURL={campaign.completionImageURL}
              showQAAnswer={activeSection === QA_SECTION && showQAAnswer}
              usesImageForVideos
              cta={campaign.useCTA ? {link: campaign.ctaLink, color: campaign.ctaColor, text: campaign.ctaText} : null}
            />
            {activeSection === QA_SECTION ? (
              <div style={{width: phonePreviewHeight/550 * 299, height:42}}>
                <Pills
                  center
                  states={['question','answer']}
                  selected={showQAAnswer ? 'answer' : 'question'}
                  onChange={(selected) => this.setState({showQAAnswer: selected === 'answer'})}
                />
              </div>
            ) : (
              <div style={{height:  42}}/>
            )}
          </Col>
        </Row>
        {NEXT_SECTION ? (
          <Row>
            <Col xs='6'>
              <br />
              <br />
              <Button
                color='primary'
                className='float-right'
                onClick={() => this.setState({
                  activeSection:NEXT_SECTION,
                  activePreviewEngagementId:NEXT_PREVIEW_ID
                })}
              >
                {this.getNextButtonText()}
              </Button>
            </Col>
            <Col xs='6'>
              <br />
              <br />
              <Button
                color='secondary'
                tag={Link}
                to={isInvite ? '/account/experiences' : '/welcome/tutorial/setup'}
              >
                {isInvite ? 'Go to your dashboard' : 'Create your first experience'}
              </Button>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col xs='12'>
              <div className='mx-auto' style={{width:170}}>
                <br />
                <br />
                <Button
                  color='primary'
                  tag={Link}
                  to={isInvite ? '/account/experiences' : '/welcome/tutorial/setup'}
                >
                  {isInvite ? 'Go to your dashboard' : 'Create your first experience'}
                </Button>
              </div>
            </Col>
          </Row>
        )}
      </div>
    )
  }
}

export default OnboardingDemo;



// WEBPACK FOOTER //
// ./src/routes/OnboardingDemo/components/OnboardingDemo.js